import { createActions } from "../../helpers/actionsHelper";
import { AnalyticsActionTypes, getAllEventsActionType, getCallEventsActionType, getTargetedEventsActionType } from "../../model/analytics/actions";
import { CallPerf, Event } from "../../model/analytics/types";

export const getAllEventsAction = createActions<AnalyticsActionTypes, any, CallPerf>(getAllEventsActionType);

export const getCallEventsAction = createActions<AnalyticsActionTypes, string, Event[]>(getCallEventsActionType);

export const getTargetedEventsAction = createActions<AnalyticsActionTypes, any, CallPerf>(getTargetedEventsActionType);

